import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleToggle = () => setMenuOpen((prev) => !prev);
  const handleClose = () => setMenuOpen(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-background-50/90 backdrop-blur-md">
      <div className="flex items-center justify-between px-6 md:px-10 py-4">
        <Link to="/" className="font-heading text-xl font-bold text-foreground-900 tracking-tight whitespace-nowrap">
          YOYBUY<span className="text-primary-500">.boats</span>
        </Link>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-8">
          <a href="#categories" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
            {t('nav_categories')}
          </a>
          <a href="#articles" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
            {t('nav_articles')}
          </a>
          <a href="#about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
            {t('nav_about')}
          </a>
        </div>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="hidden md:flex items-center gap-2 bg-primary-500 text-background-50 px-5 py-2.5 rounded-full text-sm font-medium hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
        >
          <span>{t('btn_yoybuy_sheet')}</span>
          <i className="ri-arrow-right-up-line text-sm"></i>
        </a>

        {/* Mobile hamburger */}
        <button
          onClick={handleToggle}
          className="md:hidden w-8 h-8 flex items-center justify-center text-foreground-700 cursor-pointer"
          aria-label={menuOpen ? 'Закрыть меню' : 'Открыть меню'}
        >
          {menuOpen ? (
            <i className="ri-close-line text-xl"></i>
          ) : (
            <i className="ri-menu-line text-xl"></i>
          )}
        </button>
      </div>

      {/* Mobile menu panel */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out ${
          menuOpen ? 'max-h-80 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-6 pb-6 flex flex-col gap-4 border-t border-background-200/60">
          <a
            href="#categories"
            onClick={handleClose}
            className="text-base text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap pt-4"
          >
            {t('nav_categories')}
          </a>
          <a
            href="#articles"
            onClick={handleClose}
            className="text-base text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap"
          >
            {t('nav_articles')}
          </a>
          <a
            href="#about"
            onClick={handleClose}
            className="text-base text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap"
          >
            {t('nav_about')}
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            onClick={handleClose}
            className="inline-flex items-center justify-center gap-2 bg-primary-500 text-background-50 px-5 py-3 rounded-full text-base font-medium hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer mt-2"
          >
            <span>{t('btn_yoybuy_sheet')}</span>
            <i className="ri-arrow-right-up-line text-sm"></i>
          </a>
        </div>
      </div>
    </nav>
  );
}